import {
    ADDRESS_FETCH_REQUESTED_SUCCESS,
    PERSON_FORM_SUBMIT_COMPLETED,
    PERSON_FORM_SUBMIT_FAIL,
    PERSON_FORM_SUBMIT_PENDING,
    TOGGLE_MANUAL_ADDRESS_STATE,
    EDITING_PERSON,
    ADD_PERSON
} from './PersonModal.actions';
import {
    TDeserialisedAddresses,
    TSerialisedAddresses,
    TSerialisedPerson
} from './PersonModal.types';
import { deserialiseAddresses } from './PersonModalHelper';
import {
    Person,
    deserialisePerson
} from '../../../api/lendingAPI/CustomerStateAPIHelper';
import { mergeStates } from '../../../iwProvider/StoreHelper';

const initialState = {
    ready: false,
    isEditingPerson: false,
    phones: [{}],
    addresses: [{ isPrimaryAddress: true }],
    showManualAddresses: {},
    personFormSubmitting: false
};

type TAction =
    | { type: typeof TOGGLE_MANUAL_ADDRESS_STATE; addressIndex: number }
    | {
          type: typeof PERSON_FORM_SUBMIT_PENDING;
      }
    | {
          type: typeof PERSON_FORM_SUBMIT_COMPLETED;
      }
    | {
          type: typeof PERSON_FORM_SUBMIT_FAIL;
      }
    | {
          type: typeof EDITING_PERSON;
          person: TSerialisedPerson;
      }
    | {
          type: typeof ADDRESS_FETCH_REQUESTED_SUCCESS;
          addresses: TSerialisedAddresses;
      }
    | {
          type: typeof ADD_PERSON;
      };

type TState = {
    ready: boolean;
    isEditingPerson: boolean;
    phones: object[];
    addresses: TDeserialisedAddresses;
    showManualAddresses: Record<number, boolean>;
    personFormSubmitting: boolean;
    firstName?: string;
    lastName?: string;
    uid?: string;
    title?: string;
    email?: string;
    emailUID?: string;
    dateOfBirth?: {
        day?: string | null;
        month?: string | null;
        year?: string | null;
    };
    roles?: Person['roles'];
    isApplicant?: boolean;
    isGuarantor?: boolean;
    marketing?: boolean;
};

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = mergeStates(initialState),
    action: TAction
): TState {
    switch (action.type) {
        case TOGGLE_MANUAL_ADDRESS_STATE:
            return mergeStates(state, {
                ...state,
                showManualAddresses: updateShowManualAddressState(
                    state.showManualAddresses,
                    action.addressIndex
                )
            });
        case PERSON_FORM_SUBMIT_PENDING:
            return mergeStates(state, {
                personFormSubmitting: true
            });
        case PERSON_FORM_SUBMIT_COMPLETED:
        case PERSON_FORM_SUBMIT_FAIL:
            return mergeStates(state, {
                personFormSubmitting: false
            });
        case EDITING_PERSON:
            return mergeStates(initialState, {
                isEditingPerson: true,
                ...deserialisePerson(action.person)
            });
        case ADDRESS_FETCH_REQUESTED_SUCCESS:
            return mergeStates(state, {
                addresses: deserialiseAddresses(action.addresses)
            });

        case ADD_PERSON:
            return initialState;

        default:
            return state;
    }
}

function updateShowManualAddressState(
    showManualAddresses: Record<number, boolean>,
    addressIndex: number
) {
    if (!showManualAddresses) {
        return { 0: true };
    }

    return {
        ...showManualAddresses,
        [addressIndex]: !showManualAddresses[addressIndex]
    };
}
